import React, { Component } from 'react';
import { NavLink } from 'react-router-dom'
import './index.less';

/**
 * 页头
 */
class Header extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            data: [
                {
                    title: '企业介绍',
                    target: '_blank',
                    href: '/pages/cqsx/'
                },
                {
                    title: '福利待遇',
                    target: '_blank',
                    href: '/pages/cqsx/about/'
                }, {
                    title: '招聘对象',
                    target: '_blank',
                    href: '/pages/cqsx/jobs/'
                }, {
                    title: '招聘岗位',
                    target: '_blank',
                    href: '/pages/cqsx/contact/'
                }, {
                    title: '招聘条件',
                    target: '_blank',
                    href: '/pages/cqsx/contact/'
                }, {
                    title: '招聘流程',
                    target: '_blank',
                    href: '/pages/cqsx/contact/'
                }, {
                    title: '注意事项',
                    target: '_blank',
                    href: '/pages/cqsx/contact/'
                }
            ]
        }
    }
    render() {
        var me = this;
        var dataArray = me.state.data || [];
        return (
            <div className="header">
                <div className="header__logo">
                    <a href="/pages/cqsx/" className="header__logo-link"><img src={''} /></a>
                </div>
                <ul className="header__nav">
                    {
                        dataArray.map((item) => {
                            return (
                                <li className="header__nav-item">
                                    <NavLink to={item.href} exact activeClassName="header__nav-item--active">
                                        {item.title}
                                    </NavLink>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./_source/cqsx/pages/cqsx/cmps/header/index.js